<template>
  <div>
    <div class="app-header app-header-content">
      <img src="@/assets/img/bi_order_app_v.png" class="app-header-bi">
      <div class="app-header-end" v-if="osCheck">
        <span @click="appClose()">종료</span>
      </div>
    </div>
    <div class="app-orderSel-wrap">
      <div class="app-orderSel-info">
        <div class="info-top">
          온누리상품권으로 알뜰하게!<br>
          전통시장의 정겨운 맛을!<br>
          배달로 편리하게 주문하세요<br>
        </div>
        <div class="info-bot">
          매장 가격 그대로 다양한 할인으로<br>
          <span>소상공인을 응원</span>하는 스마트 주문 앱!
        </div>
      </div>
      <!-- <div class="app-orderSel-join" @click="moveLogin"> -->
      <div class="app-orderSel-join" @click="appMemberJoin()">
        <div class="app-orderSel-joinIco"></div>
        <strong>시작하기</strong><br>
        <div class="arrow-btn2"></div>
      </div>
      <div class="app-orderSel-orderBtn" @click="appUserCodeRegister()">
        비회원으로 주문하기
        <div class="arrow-btn"></div>
      </div>
      <!-- <div class="app-install-info">
        <img src="@/assets/img/ic_20_info.png" alt="">
        비회원 주문고객은 배달비 무료가 적용되지 않습니다.
      </div> -->
    </div>
    <components
      v-if="currentComponent != null"
      :is="currentComponent"
      :visible="visible"
      :isRegister="isRegister"
      :shareData="shareData"
      :authType="authType"
      :osCheck="osCheck"
      @nextComponent="nextComponent"
      @closeComponentEmit="closeComponentToggle"
      @appClose="appClose"
      class="pop-top"
    />
    <DoubleBtnDialog
      v-if='showDoubleBtnDialogFlag'
      :message='doubleBtnMsgType'
      :onClickConfirmBtn='onClickConfirmBtn'
      :onClickCancelBtn='onClickCancelBtn'
      :imgFlag='false'/>
  </div>
</template>

<script>
import DoubleBtnDialog from '@/components/Dialog/DoubleBtnDialog.vue'
import service from '@/backend/modnpay_app_api'
import { MESSAGE_DOUBLE_BUTTON } from '@/utils/Message'
import AppSignUpAgreePage from '@/views/AppSignUpAgreePage.vue'
import AppSignUpAuthPage from '@/views/AppSignUpAuthPage.vue'
import AppSignUpPwdPage from '@/views/AppSignUpPwdPage.vue'
import AppSignUpFinPage from '@/views/AppSignUpFinPage.vue'
import { THROW_APP_ERROR } from '@/router'
export default {
  components: {
    DoubleBtnDialog,
    AppSignUpAgreePage,
    AppSignUpAuthPage,
    AppSignUpPwdPage,
    AppSignUpFinPage
  },
  data () {
    return {
      showDoubleBtnDialogFlag: false,
      onClickConfirmBtn: undefined,
      onClickCancelBtn: undefined,
      currentComponent: null,
      visible: true, // 간편회원가입 ui show/hide
      shareData: {},
      authType: 1,
      osCheck: false,
      isRegister: true
    }
  },
  mounted () {
    if (this.$store.getters.LoginAuthFlag) {
      this.currentComponent = AppSignUpAgreePage
    }
    // iPhone, iPad, iPod 중 하나라도 포함되어 있으면 iOS로 판단
    if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
      this.osCheck = true
    }

    window.backBtn = () => {
      if (localStorage.getItem('joinFlag')) { // bottomMenu, allMenuPopup에서 접근하였을때
        this.appMoveMain()
      } else if (this.currentComponent == null) {
        this.closeOrderApp()
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    localStorage.removeItem('joinFlag')
    next()
  },
  created () {
    if (localStorage.getItem('joinFlag')) {
      this.authType = 1
      this.currentComponent = AppSignUpAgreePage
    }
  },
  methods: {
    appMemberJoin () { // todo
      if (localStorage.getItem('isAuth')) {
        // 비밀번호 설정하는 페이지로 넘길 객체 정보 세팅
        const shareData = this.$store.getters.getShareData

        // 컴포넌트 전환 방식
        this.currentComponent = AppSignUpPwdPage
        this.isRegister = true
        this.shareData = shareData // 필요한 데이터 저장
      } else {
        this.currentComponent = AppSignUpAgreePage
        this.isRegister = true
      }
    },
    nextComponent (value) {
      this.currentComponent = value.componentName
      this.shareData = value.componentData
    },
    closeComponentToggle () {
      this.currentComponent = null
      this.shareData = {}

      window.backBtn = () => {
        if (localStorage.getItem('joinFlag')) { // bottomMenu, allMenuPopup에서 접근하였을때
          this.appMoveMain()
        } else if (this.currentComponent == null) {
          this.closeOrderApp()
        }
      }
    },
    async appUserCodeRegister () {
      const req = {
        deviceId: localStorage.getItem('deviceId')
      }
      const { data } = await service.appUserCodeRegister(req)
      const code = data.resultCode

      if (code === 0) {
        localStorage.setItem('appUserCode', data.userCode)
        localStorage.removeItem('Authorization')
        localStorage.removeItem('isDuplicatdLogin')
        localStorage.removeItem('isAuth')
        /**
         * TODO : 내위치 찾기 기능 미사용 주석 설정
         * */
        // this.appMoveFirstAddress()
        /**
         * TODO : 내위치 찾기 기능 사용 주석 해제
         * */
        this.currentComponent = AppSignUpAgreePage
        this.isRegister = false
        // this.$router.push({ name: LOCATION_AGREE_PAGE_NAME })
      } else {
        THROW_APP_ERROR()
      }
    },
    showDoubleBtnDialog (message, confirmBtn) { // double btn show
      this.doubleBtnMsgType = message
      this.onClickConfirmBtn = confirmBtn
      this.onClickCancelBtn = this.hideDoubleBtnDialog
      this.showDoubleBtnDialogFlag = true
    },
    hideDoubleBtnDialog () {
      this.showDoubleBtnDialogFlag = false
    },
    appClose () {
      const alertMsg = MESSAGE_DOUBLE_BUTTON[12]
      this.showDoubleBtnDialog(alertMsg, () => {
        this.closeOrderApp()
        this.hideDoubleBtnDialog()
      })
    }
  }
}
</script>

<style scoped>
</style>
